import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left */}
          <div className="lg:w-2/5">
            <Link to="/" className="inline-flex items-center gap-2 group cursor-pointer mb-5">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900 whitespace-nowrap">
                Hipo<span className="text-primary-500">Spread</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md mb-8">
              Your trusted resource for Hipobuy Spreadsheet guides, category comparisons, and smart shopping strategies. Helping thousands discover products efficiently through organized spreadsheet resources since 2024.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://twitter.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-foreground-600 text-sm"></i>
              </a>
              <a href="https://pinterest.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                <i className="ri-pinterest-line text-foreground-600 text-sm"></i>
              </a>
              <a href="https://reddit.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                <i className="ri-reddit-line text-foreground-600 text-sm"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-foreground-600 text-sm"></i>
              </a>
            </div>
          </div>

          {/* Right - Links */}
          <div className="lg:w-3/5 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Home</Link>
                <Link to="/hipobuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Spreadsheet Guide</Link>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Hipobuy Sheet</a>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">Top Categories</h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(0, 7).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">More Categories</h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(7).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background-200/70 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Hipobuy Spread. All rights reserved. For informational purposes only.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-xs text-foreground-500">Updated: July 2026</span>
            <span className="text-xs text-foreground-500">Last-modified: 2026-07-09</span>
          </div>
        </div>
      </div>
    </footer>
  );
}